  <div class="activity-feed">
    <p-panel header="{{ 'INICIO_DASHBOARD.LBL_WIDGETOFICINA' | translate}} : {{oficina}}" styleClass="p-shadow-content">
      <div class="grid" *ngIf="!carDatos">
        <div class="col-12 md:col-4 lg:col-4">
          <div class="db_ejecutivo orange">
            <div class="grid">
              <div style="position: relative" class="col-12 md:col-12 lg:col-12">
                <i style="opacity: 0.20; text-align: center; float: left;" class="fa fa-search fa-4x" aria-hidden="true"></i>
                <h1 style="margin-top: 11px; position: absolute; width: 100%; text-align: center;">{{prospectos}}</h1>
              </div>
            </div>
          </div>
          <div class="footer_ejecutivo">
            <h3 style="margin: 8px 0 5px 0; font-size: 16px; text-align: center">{{ 'INICIO_DASHBOARD.LBL_PROSPECTOS' | translate}}</h3>
          </div>
        </div>

        <div class="col-12 md:col-4 lg:col-4">
          <div class="db_ejecutivo blue">
            <div class="grid">
              <div style="position: relative" class="col-12 md:col-12 lg:col-12">
                <i style="opacity: 0.20; text-align: center; float: left;" class="fa fa-user-circle-o fa-4x" aria-hidden="true"></i>
                <h1 style="margin-top: 11px; position: absolute; width: 100%; text-align: center;">{{perfilados}}</h1>
              </div>
            </div>
          </div>
          <div class="footer_ejecutivo">
            <h3 style="margin: 8px 0 5px 0; font-size: 16px; text-align: center">{{ 'INICIO_DASHBOARD.LBL_PERFILADOS' | translate}}</h3>
          </div>
        </div>

        <div class="col-12 md:col-4 lg:col-4">
          <div class="db_ejecutivo">
            <div class="grid">
              <div style="position: relative" class="col-12 md:col-12 lg:col-12">
                <i style="opacity: 0.20; text-align: center; float: left;" class="fa fa-usd fa-4x" aria-hidden="true"></i>
                <h1 style="margin-top: 11px; position: absolute; width: 100%; text-align: center;">{{desembolsados}}</h1>
              </div>
            </div>
          </div>
          <div class="footer_ejecutivo">
            <h3 style="margin: 8px 0 5px 0; font-size: 16px; text-align: center">{{ 'INICIO_DASHBOARD.LBL_DESEMBOLSADOS' | translate}}</h3>
          </div>
        </div>
      <div *ngIf="carDatos" class="text-center">
        <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
        <span>{{'LBL_PROCESANDO' | translate }}</span>
      </div>
      </div>
    </p-panel>
  </div>

